import {map} from 'lodash';

export const RECEIVE_RECOMMENDED_COLLEGE_IDS = 'RECEIVE_RECOMMENDED_COLLEGE_IDS';

export const receiveRecommendedCollegeIds = (ids) => ({
  type: RECEIVE_RECOMMENDED_COLLEGE_IDS,
  ids: map(ids, (id) => id._id)
});
